import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { ReceiptsService } from "../../services/dao/receipts-service";
import { Box, CircularProgress } from "@mui/material";
import ReceiptDetailsCard from "./receipt-details-card";

const receiptsService = new ReceiptsService();

export default function ReceiptsDetailsScreen() {
    const [receipt, setReceipt] = useState(null);
    const { receiptId } = useParams();

    useEffect(() => {
        receiptsService.getReceipt(receiptId).then(r => { if (r?.body) setReceipt(r.body); });
    }, [receiptId]);

    if (!receipt) return <Box sx={{ display: 'flex', justifyContent: 'center', pt: 10 }}><CircularProgress /></Box>;

    return <ReceiptDetailsCard receipt={receipt} />;
}
